import React from "react";
import DataSourceListWidget from "../../components/Widgets/DataSourceWidgets/DataSourceListWidget";

const DataSourcesPage = () => {
  return <DataSourceListWidget />;
};
export default DataSourcesPage;
